export const messages = {
  en: {
    contractPartybManage: {
      search: {
        title: 'Search Conditions',
        partyB: 'Party B',
        aContacts: 'Party B Contact',
        aLink: 'Contact Phone'
      },
      list: {
        title: 'Contract Party B'
      },
      table: {
        partyB: 'Party B',
        aContacts: 'Party B Contact',
        aLink: 'Contact Phone'
      },
      form: {
        partyB: 'Party B',
        partyBPlaceholder: 'Please enter Party B',
        aContacts: 'Party B Contact',
        aContactsPlaceholder: 'Please enter Party B Contact',
        aLink: 'Contact Phone',
        aLinkPlaceholder: 'Please enter Contact Phone'
      },
      validate: {
        partyBRequired: 'Party B is required',
        partyBMaxLength: 'Party B is too long',
        aContactsRequired: 'Party B Contact is required',
        aContactsMaxLength: 'Party B Contact cannot exceed 64 characters',
        aLinkRequired: 'Contact Phone is required',
        aLinkFormat: 'Invalid Contact Phone format',
        partyBIdRequired: 'Party B ID is required'
      },
      add: {
        title: 'Add Party B'
      },
      edit: {
        title: 'Edit Party B'
      },
      delete: {
        title: 'Confirm Operation',
        confirmText: 'Are you sure to delete this Party B?'
      },
      fetchError: 'Failed to fetch Party B data'
    }
  },
  zh: {
    contractPartybManage: {
      search: {
        title: '查询条件',
        partyB: '乙方',
        aContacts: '乙方联系人',
        aLink: '联系电话'
      },
      list: {
        title: '合同乙方'
      },
      table: {
        partyB: '乙方',
        aContacts: '乙方联系人',
        aLink: '联系电话'
      },
      form: {
        partyB: '乙方',
        partyBPlaceholder: '请输入乙方',
        aContacts: '乙方联系人',
        aContactsPlaceholder: '请输入乙方联系人',
        aLink: '联系电话',
        aLinkPlaceholder: '请输入联系电话'
      },
      validate: {
        partyBRequired: '乙方不能为空',
        partyBMaxLength: '乙方太长',
        aContactsRequired: '乙方联系人不能为空',
        aContactsMaxLength: '乙方联系人不能超过64个字符',
        aLinkRequired: '联系电话不能为空',
        aLinkFormat: '联系电话格式错误',
        partyBIdRequired: '乙方编号不能为空'
      },
      add: {
        title: '添加乙方'
      },
      edit: {
        title: '修改乙方'
      },
      delete: {
        title: '请确认您的操作',
        confirmText: '确定删除合同乙方吗?'
      },
      fetchError: '获取乙方数据失败'
    }
  }
}